<div class="spinner-container" *ngIf="formDataService.isLoading">
    <app-spinner></app-spinner>
</div>

<div *ngIf="!formDataService.isLoading && formDataService.feedback == 200">
    <div class="tab-pane fade in active">
    <div class="text-center">
        <h4 class="sub">{{title}}</h4>
    </div>
    <div class='row'>
        <div class='col-xs-offset-2 col-xs-8'>
            <div class="row flex-strech">
                <div class='col-xs-12'>
                    <div class="">

                        <div class="flex-space-between">
                            <div class="text-center">
                                <div class="row">
                                    <h1 style="color:#3C3C46;">Vielen Dank für Ihre Angaben und Ihr Vertrauen</h1>
                                    <h2>Ihr Angebot für eine Immobilienrente wird erstellt.​</h2>
                                    <p>Ein DEGIV Verrentungsexperte wird Sie in Kürze kontaktieren.</p>
                                    <p>In einigen Fällen benötigen wir für eine genauere Analyse weitere Informationen von Ihnen. Sollte dies bei Ihnen der Fall sein, wird Sie ein Kundenberater in Kürze telefonisch oder mittels E-Mail kontaktieren.</p>
                                    <p>&nbsp;</p>
                                </div>
                            </div>
                            <script> gtag('event', 'conversion', { 'send_to': 'AW-654124883/e8trCI6Z5P0BENPO9LcC', 'value': 243.0, 'currency': 'EUR' }); </script> 
                        </div>
                    </div>
                </div>
            </div>      
        </div>
    </div>
</div>
<app-footer [progress]="100"></app-footer>
</div>

<div *ngIf="!formDataService.isLoading && formDataService.feedback != 200">
    <div class="tab-pane fade in active">
        <div class="text-center">
        </div>
        <div class='row'>
            <div class='col-xs-offset-2 col-xs-8'>
                <div class="row flex-strech">
                    <div class='col-xs-12'>
                        <div class="">
    
                            <div class="flex-space-between">
                                <div class="text-center">
                                    <div class="row">
                                        <h1 style="color:#3C3C46;">Sorry...</h1>
                                        <h2 style="background-color: #f20000;">Leider ist beim Abschicken ein Fehler aufgetreten.</h2>
                                        <p>Bitte versuchen Sie es erneut. Sollten weiterhin Probleme auftreten informieren Sie uns bitte per E-Mail oder Telefon.</p>
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>      
            </div>
        </div>
    </div>
</div>